export const sanatoriumFeatures = [
    {
        id: 1,
        bannerText: 'БЕСПЛАТНО', // Текст для функционального баннера
        title: 'Питание', // Новый заголовок
        description: 'Сбалансированное 3-х разовое питание по системе "Меню-заказ"\n', // Новое описание
        imageUrl: '/Assets/Services/Gym.jpg' // Примерный путь к фото
    },
    {
        id: 3,
        bannerText: 'БЕСПЛАТНО',
        title: 'Бассейн', // Новый заголовок
        description: 'Тренировки в воде также прекрасно подходят тем, кто хочет избавиться от лишних килограммов без изнуряющих физических упражнений - во время плавания задействуется все группы мышц, благодаря чему повышается их тонус, уменьшается целлюлит, сжигается жировая прослойка и, как следствие, уходят сантиметры.', // Новое описание
        imageUrl: '/Assets/Services/Bassein.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 4,
        bannerText: 'БЕСПЛАТНО',
        title: 'Комфортабельный Трансфер', // Новый заголовок
        description: 'Организуем вашу поездку с комфортом: встречаем на ж/д вокзале Кисловодска. Наши опытные водители гарантируют безопасность.', // Новое описание
        imageUrl: '/Assets/Services/Transfer.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 5,
        bannerText: 'ПЛАТНО',
        title: 'Хамам', // Новый заголовок
        description: 'Изменения в сауне наблюдаются в работе кровеносной и сосудистой систем. Под воздействием повышенной температуры усиливается сердцебиение, улучшается кровоснабжение всех отделов организма, в том числе головного мозга.', // Новое описание
        imageUrl: '/Assets/Services/Hamam.jpg' // Примерный путь к фото
    },
    {
        id: 6,
        bannerText: 'БЕСПЛАТНО',
        title: 'Бильярд', // Новый заголовок
        description: 'Бильярд – это такая игра, которая дает комплексное развитие человека – от физического до морально-психологического. За одну партию игрок проходит два-три километра, что соответствует рекомендациям врачей по поддержанию физической формы. Игра учит выигрывать, концентрировать внимание, напрягать силу воли, уравновешивать эмоции, преодолевать сопротивление противника, не терять веру в себя.', // Новое описание
        imageUrl: '/Assets/Services/1.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 7,
        bannerText: 'БЕСПЛАТНО',
        title: 'Концертный зал', // Новый заголовок
        description: 'Зал идеально подходит для проведения концертов, отчетных мероприятий, конференций, семинаров, мастер-классов, тренингов, театральных выступлений и т.д.', // Новое описание
        imageUrl: '/Assets/Services/Culture.jpg' // Примерный путь к фото
    },
];